import * as types from './mutation-types'

export const loadRelays = ({ commit, dispatch, state }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('get/relays/collection').then((response) => {
      commit(types.LOAD_RELAYS, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const loadRelayIntervals = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.get('get/relay-intervals/collection', data).then((response) => {
          commit(types.ADD_RELAYS_INTERVALS, response.data.relayInterval)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const getRelay = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`relay/${id}`).then((response) => {
      resolve(response.data)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const storeRelay = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('store/relay', data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateRelayStatus = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.put(`set-online/${id}`).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const updateRelay = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.put(`relay/${data.id}`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const deleteRelay = ({ commit, dispatch, state }, id) => {
  let route = `relay/${id}`
  return new Promise((resolve, reject) => {
    window.axios.delete(route).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getRelayInterval = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`relay-interval/${id}`).then((response) => {
      resolve(response.data)
    }).catch((err) => {
      reject(err)
    })
  })
}
export const getRelayIntervals = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`get/relay-intervals/collection`).then((response) => {
      resolve(response.data)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const storeRelayIntervals = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post(`store/relay-interval/${data.id}`, data).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const deleteRelayIntervals = ({ commit, dispatch, state }, id) => {
  let route = `relay-interval/${id}`
  return new Promise((resolve, reject) => {
    window.axios.delete(route).then((response) => {
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const updateRelayInterval = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
      window.axios.put('relay-interval/'+ data.id, data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}